import { useAssertedParams } from '@folio/lib';
import { BillingSelectionFunnelModule } from '@folio/modules';
import { useSuspenseQuery } from '@tanstack/react-query';
import {
  customerControllerGetCustomerQueryOptions,
  keyValueFieldsToObject,
  policyControllerGetPolicyQueryOptions,
} from 'korint-sdk';
import { useTranslation } from 'react-i18next';

export function MultiRisquesProBillingStep() {
  const { t } = useTranslation();
  const { customerId, branchId, policyId } = useAssertedParams();

  const { data: customer } = useSuspenseQuery({
    ...customerControllerGetCustomerQueryOptions(customerId, {
      branchId,
    }),
    select: data => ({
      ...data,
      customFields: keyValueFieldsToObject(data.customFields ?? []),
    }),
  });

  const { data: policy } = useSuspenseQuery({
    ...policyControllerGetPolicyQueryOptions(policyId, { branchId }),
    select: data => ({
      ...data,
      customFields: keyValueFieldsToObject(data.customFields ?? []),
    }),
  });

  const terminationForNonPaymentType = policy.customFields?.terminationForNonPaymentType;
  const solvabilityScore = Number(customer.customFields?.solvabilityScore);

  const alertMessage =
    terminationForNonPaymentType && terminationForNonPaymentType !== 'NO_TERMINATION' ? (
      <div>{t('axeceMultiRisquesPro.billingFrequency.terminationForNonPaymentAlert')}</div>
    ) : solvabilityScore === 2 ? (
      <div>{t('axeceMultiRisquesPro.billingFrequency.solvabilityScoreAlert')}</div>
    ) : undefined;

  return <BillingSelectionFunnelModule alertMessage={alertMessage} />;
}
